<div id="state-modal" class="modal fade show d-block modal-wf-lg">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-body mt-1 mb-3">
          <div class="row" *ngIf="!manager.isLocationOff && !chooseState">
              @if (!stateNotAllowed) {
                <div class="col-12">
                    {{timeMessage}}, It looks like you’re in {{state.name}}. Is this the state you will be visiting an office in?
                </div>
              } @else {
                <div class="col-12">
                    {{timeMessage}}, It looks like you’re in {{state.name}}.
                </div>
              }
          </div>
          <div class="row" *ngIf="manager.isLocationOff && !chooseState">
            <div class="col-12">
              {{timeMessage}}, we are currently unable to determine your current location. Please select the state you will be visiting an office in.
            </div>
          </div>
          <div class="row" *ngIf="chooseState">
            <div class="col-12">
              OK. Please enter the state you will be visiting an office in.
            </div>
          </div>
          <div class="row mt-3" *ngIf="manager.isLocationOff || stateNotAllowed || chooseState">
              <div class="col-12">
                  <select name="state" id="state" class="form-control mt-3" [ngModel]="stateName" (change)="setState($event)">
                      <option value="none">-- Select a State -- </option>
                      <option *ngFor="let state of manager.states" value="{{state.abbr}}">{{state.name}}</option>
                  </select>
              </div>
          </div>
          <div class="row mt-4" *ngIf="stateNotAllowed">
            <div class="col-12">
              Unfortunately we do not currently offer services in {{state.name}}. Please select another state to continue.
            </div>
          </div>
          <div class="row mt-4" *ngIf="allowSave">
              <div class="col-6"></div>
              <div class="col-3">
                  <div class="btn btn-outline-light me-2 full" (click)="confirmState()">Yes</div>
              </div>
              <div class="col-3">
                  <div class="btn btn-outline-secondary ms-2 full" (click)="dismissState()">No</div>
              </div>
          </div>
      </div>
    </div>
  </div>
</div>
